'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var APIVERSION = null;

var Users = function Users(baseUrl, version, axios) {
    APIVERSION = '/' + version;

    return {
        createUser: function createUser(user) {
            return axios.put(APIVERSION + '/users', user).then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        },

        updateUser: function updateUser(user) {
            return axios.put(APIVERSION + '/users', user).then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        },

        getUsers: function getUsers() {
            return axios.get(APIVERSION + '/users/all').then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        },
        getMe: function getMe(USER_ID) {
            return axios.get(APIVERSION + '/me/info').then(function (res) {
                return res;
            }).catch(function (e) {
                console.log('getting my profile error,', e);
                return e;
            });
        },
        getUser: function getUser(USER_ID) {
            return axios.get(APIVERSION + '/users/' + USER_ID).then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        },
        deleteUser: function deleteUser(USER_ID) {
            return axios.delete(APIVERSION + '/users/' + USER_ID).then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        },
        setPassword: function setPassword(payload) {
            return axios.put(APIVERSION + '/profile/password', {
                password: payload.password
            }).then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        },
        setUserToApp: function setUserToApp(USER_ID, appid) {
            return axios.put(APIVERSION + '/users/' + USER_ID + '/apps', { id: appid }).then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        },
        removeUserFromApp: function setUserToApp(USER_ID, app) {
            return axios.delete(APIVERSION + '/users/' + USER_ID + '/apps/' + app).then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        }
    };
};

exports.default = Users;